// extracted by mini-css-extract-plugin
export default {"votingInput":"VotingForm_votingInput__LEVmB","arrowDown":"VotingForm_arrowDown__7lN+t","votingBreakdown":"VotingForm_votingBreakdown__oAtjW"};